export default [{
  name: 'PERMISSION',
  value: {
    'ADMIN': 1,
    'SPACE': 2
  }
}];
